import alumni1 from "../ProjectImage/alumni1.png";
import alumni2 from "../ProjectImage/alumni2.png";
import alumni3 from "../ProjectImage/alumni3.png";
import alumni4 from "../ProjectImage/alumni4.png";
import portfolio1 from '../ProjectImage/portfolio1.png';
import portfolio2 from '../ProjectImage/portfolio2.png';
import portfolio3 from '../ProjectImage/portfolio3.png';
import math1 from '../ProjectImage/math1.png';
import math2 from '../ProjectImage/math2.png';
import personal1 from '../ProjectImage/personal1.png';
import personal2 from '../ProjectImage/personal2.png';
import weather1 from "../ProjectImage/weather1.png";
import weather2 from "../ProjectImage/weather2.png";
import currency1 from "../ProjectImage/currency1.png";
import chatapp1 from "../ProjectImage/chatapp1.png";
import chatapp2 from "../ProjectImage/chatapp2.png";
import chatapp3 from "../ProjectImage/chatapp3.png";
import chatapp4 from "../ProjectImage/chatapp4.png";
import netflix1 from "../ProjectImage/netflix1.png";
import netflix2 from "../ProjectImage/netflix2.png";
import netflix3 from "../ProjectImage/netflix3.png";



export const projects = [
  {
    id: "1",
    title: "Recipe Management Platform",
    date: "Feb 2025 – Apr 2025",
    description:
      "Developed a feature-rich web application allowing users to submit, update, and manage their personal recipes with support for images and video tutorials. Integrated token-based authentication using Laravel Sanctum to ensure secure user access and content control. Enabled multi-criteria search functionality with filters based on ingredients, difficulty level, and preparation time. Focused on modular backend development and structured frontend components to ensure long-term maintainability and extensibility.",
    images: [], // Add images if available
    tags: ["Laravel", "Blade", "MySQL", "HTML", "CSS"],
    github: "", // Add link if available
    webapp: "", // Add link if available
  },
  {
    id: "2",
    title: "E-Commerce Website",
    date: "Oct 2024 – Dec 2024",
    description:
      "Built a scalable platform with secure user authentication and role-based access control for seamless user management. Enhanced product categorization and an intuitive shopping cart system with real-time updates for a better shopping experience. Optimized performance and responsiveness, improving loading speeds, navigation, and user engagement. Improved system efficiency and responsiveness, ensuring faster load times and smoother user flow across the application.",
    images: [], // Add images if available
    tags: ["React", "Node.js", "Express", "MongoDB"],
    github: "", // Add link if available
    webapp: "", // Add link if available
  },
  {
    id: "3",
    title: "Table Reservation System",
    date: "Mar 2024 – May 2024",
    description:
      "Created a web-based system for discovering and booking tables at nearby restaurants. Integrated a dynamic reservation system with real-time availability updates, allowing users to submit bookings and receive confirmations while restaurant owners manage reservations efficiently. Developed a responsive and intuitive UI, ensuring smooth navigation across devices with an optimized frontend and backend for better user experience and operational efficiency. Added analytics for restaurant owners to track reservations, peak hours, and customer preferences.",
    images: [], // Add images if available
    tags: ["HTML", "CSS", "Bootstrap", "JavaScript", "Node.js", "MongoDB"],
    github: "", // Add link if available
    webapp: "", // Add link if available
  },
];
